import { css, cx } from '@eti/styles';
import { DangerousHtmlContent } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const listStyles = (shouldCenter, isSuccess) => css`
  border-top: 1px solid #d9d9d9;
  list-style: none;

  & :first-child {
    border-top: 0;
  }

  > .ProductCardList-item {
    font-size: 1rem;
    overflow: hidden;
    padding: 0.75rem 1rem;
    text-align: ${shouldCenter ? 'center' : 'inherit'};
    text-overflow: ellipsis;
    white-space: nowrap;
    &:nth-child(odd) {
      background-color: ${isSuccess ? '#e9f9e9' : '#f5f5f5'};
    }
  }
`;
const getKey = index => `productCardListItem-${index}`;
const ProductCardList = ({
  shouldCenter,
  className,
  items = [],
  isSuccess
}) => /*#__PURE__*/_jsx("ul", {
  className: cx(listStyles(shouldCenter, isSuccess), 'ProductCardList', className, {
    'ProductCardList--success': isSuccess
  }),
  children: items.map((item, index) => /*#__PURE__*/_jsx("li", {
    className: "ProductCardList-item",
    children: /*#__PURE__*/_jsx(DangerousHtmlContent, {
      content: item
    })
  }, getKey(index)))
});
export default ProductCardList;
//# sourceMappingURL=ProductCardList.js.map